angular.module("app").controller("AddPopupPageController", [
    '$scope',
    '$uibModalInstance',
    '$cookies',
    '$timeout',
    'popupsService',
    'pageStatuses',
    'errorHandler',
    'logger',
    'settingsService',
    'preloadedNames',
    'preloadedTypes',
    'popupTypes',
    'countryCodes',
    'status',
    'lang',
    'popupsShowOnPage',
    'newWindow',
    function ($scope, $modalInstance, $cookies, $timeout, popupsService, pageStatuses,  errorHandler, logger, settingsService, preloadedNames, preloadedTypes, popupTypes, countryCodes, status, lang, popupsShowOnPage, newWindow) {
        var init;
        var countryNameCodeMap = {};
        $scope.preloadedTypes = angular.copy(preloadedTypes);
        $scope.popupTypes = angular.copy(popupTypes);
        $scope.actualPageNames = angular.copy(preloadedNames.names);
        $scope.newWindow = newWindow;
        $scope.settings = settingsService.getSettings();
        $scope.pageStatuses = pageStatuses;
        $scope.tooltip = {
            pageTitle: "",
            custom_repeat: "",
        };
        $scope.countryCodes = countryCodes.data.map(function (item) {
            countryNameCodeMap[item.name] = item["alpha-2"];
            return item.name;
        });
        $scope.show_on_page = angular.copy(popupsShowOnPage);
        $scope.showCustomRepeatError = {
            show: false
        };

        function extractUsedNames(response) {
            $scope.usedNameShowOnPage = {};
            $scope.usedShowOnPageName = {};
            $scope.actualPageNames.forEach(function (value) {
                $scope.usedNameShowOnPage[value.name] = {};
            });

            if (response.used) {
                Object.keys(response.used).forEach(function (value) {
                    $scope.usedShowOnPageName[value] = {};
                    response.used[value].forEach(function (item) {
                        $scope.usedShowOnPageName[value][item] = true;
                        $scope.usedNameShowOnPage[item][value] = true;
                    })
                });

                if ($scope.pageData.name === "") {
                    $scope.usedNameShowOnPage[""] = {};
                    $scope.show_on_page.forEach(function (value) {
                        if ($scope.usedShowOnPageName[value] && Object.keys($scope.usedShowOnPageName[value]).length === $scope.actualPageNames.length) {
                            $scope.usedNameShowOnPage[""][value] = true;
                        }
                    });
                }
                if ($scope.pageData.show_on_page === '') {
                    $scope.usedShowOnPageName[''] = {};
                    $scope.actualPageNames.forEach(function (value) {
                        if ($scope.usedNameShowOnPage[value] && Object.keys($scope.usedNameShowOnPage[value]).length === $scope.show_on_page.length) {
                            $scope.usedShowOnPageName[""][value] = true;
                        }
                    });
                }
            }

        }

        (init = function () {
            $scope.pageData = {
                title: "",
                name:  "",
                status: status,
                login: 2,
                repeat_type: $scope.preloadedTypes[0],
                is_mobile: $scope.popupTypes[0],
                show_on_page: "",
                country: [],
                setToAllLangs: false,
                new_window: "0"
            };
            $scope.vm = {
                dateTimeFrom: "",
                dateTimeTo: ""
            };

            $scope.pageData.lang = lang;
            extractUsedNames(preloadedNames);
        })();

        $scope.submitAddPageForm = function () {
            if (!$scope.add_page_form.$valid) {
                $scope.showCustomRepeatError.show = true;
                $scope.isSavePressed = true;
                return;
            }
            delete $scope.pageData.forceTOChange;
            var requestObj = {
                popup: angular.copy($scope.pageData)
            };
            !!$scope.vm.fromDate && (requestObj.popup.start_date = $scope.vm.fromDate);
            !!$scope.vm.toDate && (requestObj.popup.end_date = $scope.vm.toDate);
            requestObj.popup.country = requestObj.popup.country.map(function (item) {
                return countryNameCodeMap[item];
            });

            popupsService.create(requestObj).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.saved");
                        init();
                        $scope.add_page_form && $scope.add_page_form.$setPristine && $scope.add_page_form.$setPristine();
                      //  $scope.$emit("force:reset:editor");
                        $modalInstance.close();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (error) {
                    errorHandler(error.message);
                }
            )
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }

        };

        $scope.handleNameChange = function () {
            $timeout(function(){
                $("#showOnPageSelect").trigger('chosen:updated');
                $("#nameSelect").trigger('chosen:updated');
            },100);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);
